import React from "react";
import clsx from "clsx";

import { TableRow, TableCell } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    minWidth: "150px",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.secondary.main,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
}));

const QuizCheatTableItem = ({ data }) => {
  const classes = useStyles();

  const getQuizCheatType = (type)=>{
    let convertedType = ""
    if (type === "Time") {
        convertedType = "خرید زمان"
    }else if (type === "RemoveWrongAnswer") {
        convertedType = "حذف پاسخ غلط"
    }else if (type === "RightAnswer") {
        convertedType = "پاسخ صحیح"
    }
    return convertedType
  }

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.owner.fullName}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.owner.nationalCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {getQuizCheatType(data.type)}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.coinUsed}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default QuizCheatTableItem